/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import SensorValue from './SensorValue'

/**
 * The InlineResponse20038 model module.
 * @module model/InlineResponse20038
 * @version 1.0.0
 */
export default class InlineResponse20038 {
  /**
   * Constructs a new <code>InlineResponse20038</code>.
   * @alias module:model/InlineResponse20038
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>InlineResponse20038</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20038} obj Optional instance to populate.
   * @return {module:model/InlineResponse20038} The populated <code>InlineResponse20038</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20038()

      if (data.hasOwnProperty('sensor_values')) {
        obj['sensor_values'] = ApiClient.convertToType(data['sensor_values'], [SensorValue])
      }
    }
    return obj
  }

  /**
   * @member {Array.<module:model/SensorValue>} sensor_values
   */
  sensor_values = undefined
}
